import {PRODUCT_SUB_TYPE, SUPPORT_STATUS} from './product';

export enum SUGGESTION_ITEM_TYPE {
  PRODUCT = 'PRODUCT',
  PRODUCT_COMPONENT = 'PRODUCT_COMPONENT',
  COMPONENT = 'COMPONENT',
  OPERATING_SYSTEM = 'OPERATING_SYSTEM',
  CMP_TYPE = 'CMP_TYPE'
}

export interface ProductSuggestion {
  itemName: string;
  itemType: SUGGESTION_ITEM_TYPE.PRODUCT |
            SUGGESTION_ITEM_TYPE.PRODUCT_COMPONENT |
            SUGGESTION_ITEM_TYPE.CMP_TYPE |
            SUGGESTION_ITEM_TYPE.COMPONENT |
            SUGGESTION_ITEM_TYPE.OPERATING_SYSTEM;
  itemVersion: string;
  smartNumber: string;
  prodId: string;
}

export interface ProductSearchResult {
  id: number;
  smartNumber: string;
  name: string;
  version: string;
  url: string;
  productStatus: string;
  productType: string;
  availabityDate: string;
  fullSuppEndDate: string;
  projObsDate: string;
  servicePackName: string;
  productSubType: PRODUCT_SUB_TYPE;
  publishingStatus: string;
  isDisabled?: boolean;
  componentId?: number;
  componentName?: string;
  componentVersion?: string;
  parentProductInfo?: any;
  parentProductType?: string;
  supportStatus: SUPPORT_STATUS;
  originalProductSmartNumber: string;
}
